import {
  FORGOT_PASSWORD,
  GET_COMPANY_INFOS,
  GET_USER,
  RESET_PASSWORD,
  SET_IS_LOGGED,
  TOGGLE_COMPANY_EXISTS,
  TOGGLE_CREATE_COMPANY,
  TOGGLE_EMAIL_EXISTS,
  TOGGLE_LOGIN,
  TOGGLE_LOGOUT,
  TOGGLE_REGISTER,
  TOKEN_IS_VALID,
  VERIFY_IF_SUB_DOMAIN_EXIST,
  VERIFY_PHONE_NUMBER
} from '../constants';
import { ICreateCompany } from '../reducers';

export function logIn(email: string, password: string, resolve: any, reject: any) {
  return {
    type: TOGGLE_LOGIN,
    email,
    password,
    resolve,
    reject
  };
}

export function getUser() {
  return {
    type: GET_USER
  };
}

export function register(
  email: string,
  password: string,
  phone: string,
  name: string,
  firstname: string,
  resolve: any,
  reject: any
) {
  return {
    type: TOGGLE_REGISTER,
    email,
    password,
    phone,
    name,
    firstname,
    resolve,
    reject
  };
}

export function verifyPhoneNumber(smsCode: string, resolve: any, reject: any) {
  return {
    type: VERIFY_PHONE_NUMBER,
    smsCode,
    resolve,
    reject
  };
}

export function verifyIfSubDomainDoesExist(subDomain: string, resolve: any, reject: any) {
  return {
    type: VERIFY_IF_SUB_DOMAIN_EXIST,
    subDomain,
    resolve,
    reject
  };
}

export function logOut(resolve: any, reject: any) {
  return {
    type: TOGGLE_LOGOUT,
    resolve,
    reject
  };
}

export function getCompanyInfos(resolve: any, reject: any, company: string) {
  return {
    type: GET_COMPANY_INFOS,
    resolve,
    reject,
    company
  };
}

export function emailExists(resolve: any, reject: any, email: string) {
  return {
    type: TOGGLE_EMAIL_EXISTS,
    resolve,
    reject,
    email
  };
}

export function companyExists(resolve: any, reject: any, siren: string) {
  return {
    type: TOGGLE_COMPANY_EXISTS,
    resolve,
    reject,
    siren
  };
}

export function createCompany(resolve: any, reject: any, infos: ICreateCompany) {
  return {
    type: TOGGLE_CREATE_COMPANY,
    resolve,
    reject,
    infos
  };
}

export function setIsLogged(value: boolean) {
  return {
    type: SET_IS_LOGGED,
    value
  };
}

export function tokenIsValid(resolve: any, reject: any) {
  return {
    type: TOKEN_IS_VALID,
    resolve,
    reject
  };
}

export function forgotPassword(email: string, resolve: any, reject: any) {
  return {
    type: FORGOT_PASSWORD,
    email,
    resolve,
    reject
  };
}

export function resetPassword(password: string, token: string, resolve: any, reject: any) {
  return {
    type: RESET_PASSWORD,
    password,
    token,
    resolve,
    reject
  };
}
